var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./compareCoverage.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-72d1c53a\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./compareCoverage.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/economy/components/compareCoverage.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] compareCoverage.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-72d1c53a", Component.options)
  } else {
    hotAPI.reload("data-v-72d1c53a", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/economy/components/compareCoverage.vue
// module id = 700
// module chunks = 0